import { useEffect } from 'react'
import getFeatureEditor from '@chegg-wt/core-wa/utils/getEditor'
import { EditorUpdateEvent, PaperStatus } from '@chegg-wt/core-wa/types'
import { useSelector, useDispatch } from 'react-redux'
import {
  feedbacksSelector,
  paperIdSelector,
  paperRequiresRecheckSelector,
  paperStatusSelector,
  sentenceOffsetsSelector,
  totalFeedbackCountSelector,
  wordCountSelector,
} from '@chegg-wt/core-wa/state/selectors'
import { onEditorUpdate } from '@chegg-wt/core-wa/utils/manualEditHelpers'
import { store } from '@chegg-wt/core/state'

export const useOnEditorUpdate = () => {
  const editor = getFeatureEditor()
  const sentenceOffsets = useSelector(sentenceOffsetsSelector)
  const feedbacks = useSelector(feedbacksSelector)
  const wordCount = useSelector(wordCountSelector)
  const totalFeedbackCount = useSelector(totalFeedbackCountSelector)

  const paperId = useSelector(paperIdSelector)
  const paperRequiresRecheck = useSelector(paperRequiresRecheckSelector)
  const isDraftPaper = useSelector(paperStatusSelector) === PaperStatus.DRAFT

  const dispatch = useDispatch()

  useEffect(() => {
    const updateHandler = (event: EditorUpdateEvent) => {
      onEditorUpdate({
        editorUpdateEvent: event,
        sentenceOffsets: sentenceOffsetsSelector(store.getState()), // Required to pass updated sentenceOffsets in synchrounous flow of editor events
        feedbacks,
        wordCount,
        dispatch,
        paperId,
        paperRequiresRecheck,
        isDraftPaper,
        totalFeedbackCount,
      })
    }
    editor?.on('update', updateHandler)
    return () => {
      editor?.off('update', updateHandler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editor, sentenceOffsets, feedbacks, wordCount, paperRequiresRecheck, isDraftPaper])
}
